import React from "react";
import { Route, Routes } from "react-router-dom";
import { EditAppSettings } from "./containers";

export const AppSettings = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<EditAppSettings />} />
      </Routes>
    </>
  );
};
